import React from 'react';
import RecentProject from './RecentProject/RecentProject';

function index() {
    return (
        <>
            <RecentProject />
        </>
    )
}

export default index